<template>
  <vc-date-picker
    :key="calendarKey"
    :timezone="timezone"
    color="green"
    :is-dark="isDark"
    v-model="range"
    :columns="$screens({ default: 1, md: 2, lg: 2 })"
    mode="dateTime"
    is24hr
    is-range
  >
    <template v-slot="{ inputValue, togglePopover }">
      <v-text-field
        readonly
        label="Временной интервал"
        class="pointer"
        :value="`${inputValue.start} - ${inputValue.end}`"
        @click="togglePopover()"
      >
      </v-text-field>
      <div class="input_top">
        <v-chip-group class="children-chips" column>
          <v-chip small @click="setRange('today')"> Сегодня </v-chip>
          <v-chip small @click="setRange('yesterday')"> Вчера </v-chip>
          <v-chip small @click="setRange('week')"> Неделя </v-chip>
          <v-chip small @click="setRange('month')"> Месяц </v-chip>
          <v-chip small @click="setRange('current_month')"> Этот месяц </v-chip>
          <v-chip small @click="setRange('last_month')"> Предыдущий месяц </v-chip>
        </v-chip-group>
      </div>
    </template>
  </vc-date-picker>
</template>

<script>
import moment from 'moment'

export default {
  props: {
    value: {
      type: Object,
      required: true,
    },
    timezone: {
      type: String,
      default: 'Europe/Moscow',
    },
    default: {},
  },

  data() {
    return {
      calendarKey: 0,
      defaultDate: {
        start: moment().startOf('day').toDate(),
        end: moment().endOf('day').toDate(),
      },
    }
  },

  computed: {
    range: {
      get() {
        if (Object.keys(this.value).length === 0) {
          this.$emit('input', this.defaultDate)
        }
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      },
    },
    isDark() {
      return !!this.$vuetify.theme.dark
    },
  },

  methods: {
    setRange(range) {
      let ranges = {
        today: {
          start: moment().startOf('day').toDate(),
          end: moment().endOf('day').toDate()
        },
        yesterday: {
          start: moment().subtract(1, 'day').startOf('day').toDate(),
          end: moment().subtract(1, 'day').endOf('day').toDate()
        },
        week: {
          start: moment().subtract(7, 'day').startOf('day').toDate(),
          end: moment().endOf('day').toDate()
        },
        month: {
          start: moment().subtract(1, 'month').startOf('day').toDate(),
          end: moment().endOf('day').toDate()
        },
        current_month: {
          start: moment().startOf('month').startOf('day').toDate(),
          end: moment().endOf('month').endOf('day').toDate()
        },
        last_month: {
          start: moment().subtract(1, 'month').startOf('month').startOf('day').toDate(),
          end: moment().subtract(1, 'month').endOf('month').endOf('day').toDate()
        },
      }

      this.range.start = ranges[range].start
      this.range.end = ranges[range].end

      this.calendarKey++
    },
  },

  mounted() {
    if (this.default) this.defaultDate = this.default
  },
}
</script>

<style scoped>
.input_top {
  position: relative;
  height: 4rem;
}

.input_top > .children-chips {
  /*left: 4.5rem;*/
  top: -1.5rem;
}

.pointer div input {
  cursor: pointer;
}
</style>
